export const fetchHeatmapColomnOutliersStarted = (state) => {
    return {
        ...state,
        heatmapOuliersApi: {
            isProcessing: true,
            error: false
        }
    }

}

export const fetchHeatmapColomnOutliersSuccess = (state, payload) => {
    return {
        ...state,
        heatmapOuliersApi: {
            isProcessing: false,
            error: false,
            data: payload.data.data
        },
    }

}

export const fetchHeatmapColomnOutliersFailed = (state, payload) => {
    return {
        ...state,
        heatmapOuliersApi: {
            data:undefined,
            isProcessing: false,
            error: true
        },
    }

}